import { Box, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  url?: string;
  label?: string;
  id?: string;
  platformId?: number;
  company?: string;
}

const MonitoringJobItem: FC<Props> = ({ url, label }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [platform, setPlatform] = useState('');

  const extractPlatform = (url: string) => {
    const urlParts = url.split('.');
    setPlatform(urlParts[1]);
  };

  useEffect(() => {
    if (!url) return;
    extractPlatform(url);
  }, [url]);

  return (
    <Box
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        flexGrow: 2,
        '& :not(:last-child)': {
          borderBottom: 'none !important',
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontWeight: 700,
            lineHeight: theme.typography.caption.lineHeight,
            mt: theme.spacing(3),
          }}
          variant="overline"
        >
          {t('monitoring_label')}
        </Typography>
        <Typography
          sx={{ color: theme.palette.text.secondary }}
          variant="subtitle2"
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontWeight: 700,
            lineHeight: theme.typography.caption.lineHeight,
            mt: theme.spacing(1),
          }}
          variant="overline"
        >
          {t('platform')}
        </Typography>
        <Typography
          sx={{ color: theme.palette.text.secondary }}
          variant="subtitle2"
        >
          {platform === undefined ? 'google' : platform}
        </Typography>
        <Typography
          sx={{
            fontWeight: 700,
            lineHeight: theme.typography.caption.lineHeight,
            mt: theme.spacing(1),
          }}
          variant="overline"
        >
          {t('url')}
        </Typography>
        <Typography
          sx={{ color: theme.palette.text.secondary }}
          variant="subtitle2"
        >
          {url}
        </Typography>
      </Box>
    </Box>
  );
};

export default MonitoringJobItem;
